import "core-js/modules/es.array.concat.js";
var prefixClass = 'cfmoto-dialog';
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'alert'
    },
    title: {
      type: String,
      default: '信息提示'
    },
    message: {
      type: String,
      default: ''
    },
    showCancel: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: '确&nbsp;定'
    },
    cancelText: {
      type: String,
      default: '取&nbsp;消'
    },
    onCancel: {
      type: Function
    },
    onConfirm: {
      type: Function
    },
    top: {
      type: String,
      default: '50%'
    },
    left: {
      type: String,
      default: '50%'
    }
  },
  emits: ['update:modelValue'],
  components: {},
  data: function data() {
    return {
      interval: 0,
      visible: this.modelValue,
      showTime: 0,
      isClosed: false
    };
  },
  computed: {
    classes: function classes() {
      return "".concat(prefixClass, " ").concat(prefixClass, "-").concat(this.type || 'alert');
    },
    iconClass: function iconClass() {
      return {
        warning: 'iconfont-warning',
        success: 'iconfont-chenggong',
        fail: 'iconfont-shibai',
        error: 'iconfont-cry',
        msg: 'iconfont-warning'
      }[this.type];
    },
    styles: function styles() {
      var top = this.top,
        left = this.left;
      return {
        top: top,
        left: left
      };
    }
  },
  methods: {
    show: function show() {
      var _this = this;
      var $content = this.$el.querySelector('.dialog-containner');
      this.isClosed = false;
      this.visible = true;
      this.$nextTick(function () {
        var width = "".concat(-$content.clientWidth / 2, "px");
        var height = "".concat(-$content.clientHeight / 2, "px");
        _this.styles.left = '50%';
        _this.styles.top = '50%';
        _this.styles.marginLeft = width;
        _this.styles.marginTop = height;
      });
      if (this.showTime) {
        this.closeMyself();
      }
    },
    destroyElement: function destroyElement() {
      this.$el.removeEventListener('transitionend', this.destroyElement);
      // this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    close: function close() {
      this.isClosed = true;
      this.visible = false;
      // this.$el.addEventListener('transitionend', this.destroyElement);
      this.destroyElement();
    },
    closeMyself: function closeMyself() {
      var _this2 = this;
      var timer = setTimeout(function () {
        if (_this2.isClosed) {
          return;
        }
        _this2.destroyElement();
        clearTimeout(timer);
      }, this.showTime);
    },
    handleCancel: function handleCancel() {
      if (this.onCancel) {
        this.onCancel(this);
      }
      this.close();
    },
    handleConfirm: function handleConfirm() {
      if (this.onConfirm) {
        this.onConfirm(this);
      }
      this.close();
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  beforeUnmount: function beforeUnmount() {},
  watch: {
    modelValue: function modelValue() {
      this.visible = this.modelValue;
    },
    visible: function visible() {
      this.$emit('update:modelValue', this.visible);
    }
  }
};